import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';
import { IconArrowRight } from '@divlab/divanui/icons';

import * as PageProductStore from '@Stores/PageProduct';
import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import styles from './FabricSampleOrderingPanel.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';

export interface ButtonProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const FabricSampleOrderingPanel: FC<ButtonProps> = (props) => {
  const { className, ...restProps } = props;
  const {
    product: { modelId },
  } = PageProductStore.useData();
  const { t } = useTranslation();

  const handleClickOrderSamples = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      ModalWindows.open('OrderTextileSamples', { modelId });
    },
    [modelId],
  );

  return (
    <div
      {...restProps}
      className={cn(styles.panel, className)}
      onClick={handleClickOrderSamples}
      data-testid='textile-samples'
    >
      <div className={styles.container}>
        <div className={styles.title}>
          {t('constructor-order-fabric-samples')}
          <IconArrowRight className={styles.chevron} />
        </div>

        <div className={styles.condition}>{t('order-fabric-samples-condition')}</div>
      </div>
    </div>
  );
};

export default memo(FabricSampleOrderingPanel);
